import React from 'react';
import IconButtonBase from './IconButtonBase';
import { TIconButton } from './types';

const Primary = ({ as = 'button', ...rest }: TIconButton) => <IconButtonBase {...rest} as={as} kind="primary" />;

export default Primary;
